module.exports = __webpack_public_path__ + "static/img/madam_classroom.166a54aa.png";